/** Атрибут на `<html>`: приложение гидрировано */
export const APP_HYDRATED_ATTRIBUTE = 'data-app-hydrated';

/** Атрибут на `<html>`: корневой error boundary вернул серверную разметку */
export const APP_DEGRADED_ATTRIBUTE = 'data-app-degraded';
